export default __webpack_public_path__ + "static/lozenge-icon-dont-dark-e4027ca86c4a88547fe868206e620bccac1079faad10719ff89e29679d93b1f8.png";